/**
 * formatting the notificationTemplates config (KPA)
 * @param {*} data
 */
export const formatRemainderListData = data => {
  const TABLE_DATA = []
  // API Response is an array
  TABLE_DATA[0] = {
    remainder: 'Default',
    period: `${getTemplateInterval(data)} days`,
    message: data.defaultReminderMessage,
    conditions: '',
  }
  data.userSelectionCriteria.conditions.forEach((_elm, i) => {
    TABLE_DATA[i + 1] = {
      remainder: `Conditional Reminder ${i + 1}`,
      conditions: `Reminder Period ${_elm.when} ${_elm.num} day(s)`,
      period: '',
      message: _elm.formatText,
    }
  })
  return TABLE_DATA
}

export const getTemplateInterval = data => {
  return data.rRuleTemplate.split('INTERVAL=')[1]
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NotificationRemaindersTable/Utilities.js